<template>
  <v-dialog
    v-model="show_dialog"
    persistent
    width="200"
    overlay-opacity="0.6"
    overlay-color="#171d64"
    content-class="pzse-redirect-dialog"
  >
    <div class="pzse-loader">
      <div class="pzse-loader__spinner-wrap">
        <svg
          class="pzse-loader__svg"
          viewBox="0 0 72 72"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="36"
            cy="36"
            r="29"
            stroke="rgba(255,255,255,0.2)"
            stroke-width="5"
          />
          <circle
            class="pzse-loader__arc"
            cx="36"
            cy="36"
            r="29"
            stroke="#fdbe35"
            stroke-width="5"
            stroke-linecap="round"
            stroke-dasharray="50 132"
            transform="rotate(-90 36 36)"
          />
        </svg>
        <div class="pzse-loader__inner-dot"></div>
      </div>

      <p class="pzse-loader__label">Loading page…</p>
      <p class="pzse-loader__sub">Please wait a moment</p>
    </div>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "PageRedirectLoaderDialog",
  computed: {
    ...mapState({
      show_dialog: state => state.is_redirecting
    })
  }
};
</script>

<style>
.pzse-redirect-dialog {
  background: transparent !important;
  box-shadow: none !important;
  overflow: visible !important;
}
</style>

<style scoped>
.pzse-loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  animation: loader-enter 0.3s ease both;
}

@keyframes loader-enter {
  from {
    opacity: 0;
    transform: translateY(8px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.pzse-loader__spinner-wrap {
  position: relative;
  width: 72px;
  height: 72px;
  margin-bottom: 20px;
}

.pzse-loader__svg {
  width: 72px;
  height: 72px;
  animation: arc-spin 1.1s linear infinite;
}

@keyframes arc-spin {
  to {
    transform: rotate(360deg);
  }
}

.pzse-loader__arc {
  filter: drop-shadow(0 0 6px rgba(253, 190, 53, 0.7));
}

.pzse-loader__inner-dot {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #fdbe35;
  opacity: 0.9;
  box-shadow: 0 0 12px 4px rgba(253, 190, 53, 0.35);
  animation: dot-breathe 1.1s ease-in-out infinite;
}

@keyframes dot-breathe {
  0%,
  100% {
    opacity: 0.9;
    transform: translate(-50%, -50%) scale(1);
  }

  50% {
    opacity: 0.5;
    transform: translate(-50%, -50%) scale(0.75);
  }
}

.pzse-loader__label {
  margin: 0 0 6px;
  font-size: 15px;
  font-weight: 600;
  color: #fff;
  letter-spacing: 0.01em;
  text-align: center;
  text-shadow: 0 1px 8px rgba(0, 0, 0, 0.4);
}

.pzse-loader__sub {
  margin: 0;
  font-size: 11px;
  font-weight: 400;
  color: #fdbe35;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  text-align: center;
  text-shadow: 0 1px 6px rgba(0, 0, 0, 0.4);
}
</style>
